import axios from "./axios";

function readBlobAsText(blob) {
  if (typeof blob?.text === "function") return blob.text();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
}

async function requirePdfBlob(data) {
  if (!(data instanceof Blob)) {
    const err = new Error("Invalid pdf");
    err.code = "PAYSLIP_PDF_INVALID";
    throw err;
  }
  const header = await readBlobAsText(data.slice(0, 4));
  if (header !== "%PDF") {
    let message = "Invalid pdf";
    try {
      const json = JSON.parse(await readBlobAsText(data));
      if (Array.isArray(json.errors) && json.errors.length) {
        message = json.errors.join(", ");
      }
    } catch (_) {
      /* HTML or empty error body */
    }
    const err = new Error(message);
    err.code = "PAYSLIP_PDF_INVALID";
    throw err;
  }
  return data;
}

export async function fetchPayslips(params = {}) {
  return axios.get("/payslips", { params });
}

export async function downloadPayslipPdf(id) {
  try {
    const response = await axios.get(`/payslips/${id}/pdf`, {
      responseType: "blob",
      headers: { Accept: "application/pdf" },
    });
    const blob = await requirePdfBlob(response.data);
    return { ...response, data: blob };
  } catch (error) {
    if (error?.code === "PAYSLIP_PDF_INVALID") throw error;
    const data = error?.response?.data;
    if (data instanceof Blob) {
      await requirePdfBlob(data);
    }
    throw error;
  }
}

export async function queuePayslipSync(payload = {}) {
  return axios.post("/tripletex/payslips/sync", payload);
}
